import styled from 'styled-components';
import Typography from '../atoms/Typography';
import SvgIcon from '../atoms/SvgIcon';

const CheckboxContainer = styled.div`
  display: inline-flex;
  cursor: pointer;
  vertical-align: middle;
  align-items: center;
  gap: 8px;
`;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

interface Props {
  checked: boolean;
  borderRadius?: string;
}

const StyledCheckbox = styled.div<Props>`
  display: flex;
  width: 24px;
  height: 24px;
  background-color: ${(props) =>
    props.checked ? '#4CAF50' : 'white'} !important;
  border-radius: ${(props) => props.borderRadius};
  border: ${(props) =>
    props.checked ? '2px solid #4CAF50' : '2px solid #2c2c2c'} !important;
  transition: all 150ms;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px white;
  }
`;

const CheckBox = ({ checked, labelKey, borderRadius, ...props }) => (
  <CheckboxContainer>
    <HiddenCheckbox defaultValue={checked} {...props} />
    <StyledCheckbox checked={checked} borderRadius={borderRadius}>
      <SvgIcon icon="check" color="white" iconSize="xLarge" />
    </StyledCheckbox>
    <Typography variant="body1" translateKey={labelKey} />
  </CheckboxContainer>
);

export default CheckBox;
